import { useNavigate, useLocation } from 'react-router-dom'
import { Column } from 'src/shared/components/Semantic/all'
import { paths } from 'src/routes/paths'
import { useAuth } from 'src/shared/hooks/authProvider'
import { SidebarAccountButton } from './SidebarAccountButton'

export const SidebarFooter = ({
  isCollapsed = false,
}: {
  isCollapsed?: boolean
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { session } = useAuth()
  const loggedIn = !!session?.user?.email

  if (!loggedIn) return null

  const handleOrganizationClick = () => {
    if (
      location.pathname.startsWith(paths.myAccount) ||
      location.pathname.startsWith(paths.admin)
    ) {
      navigate(paths.myAccount + paths.settings)
    } else {
      navigate(paths.myAccount + paths.dashboard)
    }
  }

  return (
    <Column className="mt-auto border-t border-border/50 pt-3">
      <SidebarAccountButton
        onClick={handleOrganizationClick}
        isCollapsed={isCollapsed}
      />
    </Column>
  )
}
